module.exports = __webpack_public_path__ + "static/media/img006.a61a728c.jpg";